import { DatesProvider } from '@mantine/dates'
import { globalLanguageStore, translate } from 'i18n/i18n'
import React from 'react'

export const I18nWrapper = (props: { children: React.ReactNode }) => {
  const globalLanguage = globalLanguageStore.useSelector((lng) => lng)

  return (
    <React.Fragment key={globalLanguage}>
      {/* weekendDays: [] keeps weekends the same colour as other days, as UX asked */}
      <DatesProvider
        settings={{
          locale: globalLanguage,
          firstDayOfWeek: translate.dates.firstDayOfWeek(),
          weekendDays: [],
        }}
      >
        {props.children}
      </DatesProvider>
    </React.Fragment>
  )
}
